export type Category = {
  id: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
};

export type Topic = {
  id: string;
  title: string;
  summary: string;
  categoryId: string;
  categoryName: string;
  tags: string[];
  author: string;
  authorTitle: string;
  cover: string;
  heat: number;
  commentCount: number;
  likeCount: number;
  updatedAt: string;
  readingMinutes: number;
  content: string[];
  opinions: { user: string; stance: string; text: string; like: number }[];
  comments: { id: string; user: string; avatarText: string; time: string; text: string; like: number; replies?: { user: string; text: string }[] }[];
};

export const categories: Category[] = [
  { id: "all", name: "全部话题", desc: "社区里正在被讨论的一切", icon: "ri-fire-line", count: 1286 },
  { id: "film", name: "影视热议", desc: "新剧、电影、角色与剧情走向", icon: "ri-film-line", count: 426 },
  { id: "show", name: "综艺现场", desc: "综艺名场面与嘉宾表现", icon: "ri-tv-2-line", count: 238 },
  { id: "stage", name: "舞台演出", desc: "演唱会、音乐节、Live 现场", icon: "ri-mic-line", count: 175 },
  { id: "net", name: "网络热点", desc: "热搜词条与全网热梗", icon: "ri-flashlight-line", count: 301 },
  { id: "music", name: "音乐榜单", desc: "新歌上线与榜单变化", icon: "ri-music-2-line", count: 146 },
];

export const topics: Topic[] = [
  {
    id: "1",
    title: "今年口碑逆袭的那部剧,到底是怎么把观众追回来的?",
    summary: "开播评分只有 5.9,大结局后一路涨到 8.4。这部剧的翻红过程,几乎成了今年影视圈最值得研究的样本。",
    categoryId: "film",
    categoryName: "影视热议",
    tags: ["口碑逆袭", "剧情讨论", "角色分析"],
    author: "追剧的橘子",
    authorTitle: "影视区常驻楼主",
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20a%20glowing%20film%20reel%20and%20theater%20curtain%2C%20warm%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=800&height=600&seq=gossip-topic-film-01&orientation=landscape",
    heat: 98200,
    commentCount: 1264,
    likeCount: 8420,
    updatedAt: "12 分钟前",
    readingMinutes: 6,
    content: [
      "这部剧最开始的处境其实并不好。前三集体量小、节奏慢,加上主角出场方式比较克制,很多观众在弹幕里直接说「看不下去」。开分 5.9,几乎是同档期里最不起眼的一部。",
      "真正的转折出现在第八集。那场长达十一分钟的一镜到底,把前面埋的所有伏笔一次性收拢,很多原本弃剧的观众被短视频片段重新拉了回来。有网友统计,那一周剧集的重播率比首播还高。",
      "更关键的是,制作方没有急着解释,而是让角色自己在后续剧情里完成情绪闭环。这种「不追着观众跑」的处理方式,反而让讨论区安静下来,开始认真聊剧情本身。",
      "从社区里上千条讨论来看,大家真正在意的并不是反转有多猛,而是人物动机能不能自洽。这也是这部剧后期评分回升的根本原因——它把最初被吐槽的「慢」,重新定义成了「耐心」。",
    ],
    opinions: [
      { user: "深夜看片人", stance: "支持方", text: "前三集的铺垫确实需要耐心,但第八集之后回看,每一帧都不是白给的。", like: 1284 },
      { user: "半糖不加冰", stance: "中立", text: "我承认后期好看,但前期节奏问题还是客观存在的,不能全归为「观众没耐心」。", like: 892 },
      { user: "剪辑室老王", stance: "结构派", text: "它真正的厉害之处是回收伏笔的方式,几乎没有一句废台词。", like: 651 },
    ],
    comments: [
      { id: "c1", user: "雾里看花", avatarText: "雾", time: "8 分钟前", text: "第八集那段一镜到底我反复看了三遍,配乐一起鸡皮疙瘩就起来了。", like: 342, replies: [{ user: "追剧的橘子", text: "很多人都这么说,那段确实是全剧分水岭。" }] },
      { id: "c2", user: "奶茶三分糖", avatarText: "奶", time: "25 分钟前", text: "我是被室友安利回来的,现在比她还上头,已经二刷了。", like: 218 },
      { id: "c3", user: "键盘上的猫", avatarText: "键", time: "1 小时前", text: "希望以后多一点这种慢慢讲故事的剧,别老想着三集定生死。", like: 176 },
    ],
  },
  {
    id: "2",
    title: "综艺里那个「尴尬又真实」的名场面,为什么大家边吐槽边追?",
    summary: "一段三分半的对话被剪成几十个版本,有人说是剧本,有人说是真实反应。这届观众到底在为什么买单?",
    categoryId: "show",
    categoryName: "综艺现场",
    tags: ["名场面", "剪辑讨论", "真实感"],
    author: "综艺观察员",
    authorTitle: "综艺区活跃网友",
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20a%20vintage%20television%20set%20with%20speech%20bubbles%2C%20warm%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=800&height=600&seq=gossip-topic-show-02&orientation=landscape",
    heat: 76500,
    commentCount: 986,
    likeCount: 6120,
    updatedAt: "34 分钟前",
    readingMinutes: 5,
    content: [
      "这段对话之所以能出圈,恰恰是因为它「不完美」。嘉宾停顿了三秒才接话,导演组也没有剪掉这段沉默,反而完整保留了下来。",
      "有网友把这段拆成逐帧分析,发现镜头在关键处有一次明显的轻微晃动,说明现场确实出现了一个没被安排的瞬间。这类细节,成了讨论区最爱的「考据素材」。",
      "社区里有一条高赞评论说得挺到位:观众现在追综艺,追的不是完美演出,而是那种「原来他们也会不知道说什么」的真实感。",
      "当然也有理性派提醒,综艺终归是经过剪辑的表达,不必把每一帧都当作真相。这种一边追、一边保持清醒的状态,反倒是这届观众比较健康的心态。",
    ],
    opinions: [
      { user: "遥控器争夺者", stance: "真实派", text: "那三秒沉默比任何台词都好看,能留在正片里说明剪辑师也懂。", like: 764 },
      { user: "剪辑学徒小林", stance: "理性派", text: "镜头晃动只能说明有意外,不能证明没有剧本,别过度解读。", like: 523 },
    ],
    comments: [
      { id: "c1", user: "沙发上的土豆", avatarText: "土", time: "15 分钟前", text: "我就是为了这三分钟把这期完整看完了,太真实了。", like: 187 },
      { id: "c2", user: "说走就走的周末", avatarText: "周", time: "52 分钟前", text: "理性追综,开心就好,别给自己加太多戏。", like: 143 },
    ],
  },
  {
    id: "3",
    title: "音乐节抢票又一次刷屏,今年现场的体验真的变好了吗?",
    summary: "从排队入场到散场交通,去过现场的人说法两极化。我们把社区里的真实反馈整理成了一份现场体感报告。",
    categoryId: "stage",
    categoryName: "舞台演出",
    tags: ["音乐节", "现场体验", "抢票"],
    author: "现场第一排",
    authorTitle: "演出区资深乐迷",
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20a%20concert%20stage%20with%20light%20beams%20and%20crowd%20silhouettes%2C%20warm%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=800&height=600&seq=gossip-topic-stage-03&orientation=landscape",
    heat: 64100,
    commentCount: 742,
    likeCount: 4980,
    updatedAt: "1 小时前",
    readingMinutes: 7,
    content: [
      "抢票这件事,每年都在上演同样的剧本:开票十秒秒空,评论区一半在求票,一半在吐槽系统。但真正值得聊的,是抢到票之后的那几天现场体验。",
      "从社区收集的上百条反馈看,今年最大的进步在入场分流。多个场地启用了分时段入场,排队时间比去年平均缩短了将近四十分钟。",
      "但问题也很集中:散场交通仍然是最大的痛点。有乐迷留言说,最后一首歌结束到坐上接驳车,整整等了一个半小时。",
      "所以今年现场体验到底算不算变好?比较客观的结论是——前半程明显优化,后半程还有得改。这种「一半及格一半待补」的评价,反而比一边倒的好评更有参考价值。",
    ],
    opinions: [
      { user: "前排的耳机", stance: "好评派", text: "分时段入场是真的香,今年几乎没怎么排长队。", like: 612 },
      { user: "末班车选手", stance: "吐槽派", text: "散场太折磨了,建议主办方把接驳车数量翻一倍。", like: 588 },
    ],
    comments: [
      { id: "c1", user: "热爱摇滚的中年人", avatarText: "摇", time: "2 小时前", text: "体验可以更好,但能在现场听到那首歌,值了。", like: 231 },
    ],
  },
  {
    id: "4",
    title: "一个热梗的生命周期有多长?从刷屏到没人提,只用了两周",
    summary: "网络热点来得快去得也快。我们复盘了一个热梗的完整走红路径,顺便聊聊为什么大家越来越「不恋战」。",
    categoryId: "net",
    categoryName: "网络热点",
    tags: ["网络热梗", "传播观察", "情绪周期"],
    author: "网感研究所",
    authorTitle: "热点区观察者",
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20rising%20trend%20arrows%20and%20floating%20speech%20bubbles%2C%20warm%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=800&height=600&seq=gossip-topic-net-04&orientation=landscape",
    heat: 58900,
    commentCount: 654,
    likeCount: 4020,
    updatedAt: "2 小时前",
    readingMinutes: 4,
    content: [
      "一个热梗从出现到无人提及,平均只需要两到三周。这个周期比三年前缩短了一半还多。",
      "第一阶段是「发现」,通常由几条高传播度的评论或短视频引爆;第二阶段是「模仿」,各类账号开始套用同一个句式;第三阶段是「疲劳」,当同一个梗出现频率过高,用户会本能地开始反感。",
      "有意思的是,真正让热梗加速退场的,往往不是它不好笑,而是它被过度使用了。社区里有人说得很形象:「不是梗过时了,是刷得太多让人腻了。」",
      "对内容创作者来说,这其实是个提醒:与其追着已经过气的梗跑,不如把精力放在能长期被讨论的话题上。",
    ],
    opinions: [
      { user: "冲浪十级选手", stance: "梗文化爱好者", text: "梗本身没问题,问题是被商家和账号用滥了。", like: 498 },
      { user: "冷静观察者", stance: "理性派", text: "两周生命周期很正常,信息密度这么高,没人有精力恋战。", like: 376 },
    ],
    comments: [
      { id: "c1", user: "潜水的老网民", avatarText: "潜", time: "3 小时前", text: "说得太对了,现在我基本看到第三次就滑走了。", like: 165 },
    ],
  },
  {
    id: "5",
    title: "新歌上线四十八小时,榜单变化说明了什么?",
    summary: "发歌前声势浩大,上榜后走势却比预期平缓。从数据看一首歌的「后劲」,其实比首日成绩更有意思。",
    categoryId: "music",
    categoryName: "音乐榜单",
    tags: ["新歌", "榜单数据", "后劲"],
    author: "耳机里的风",
    authorTitle: "音乐区数据党",
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20headphones%20and%20sound%20waves%20with%20chart%20lines%2C%20warm%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=800&height=600&seq=gossip-topic-music-05&orientation=landscape",
    heat: 47200,
    commentCount: 521,
    likeCount: 3310,
    updatedAt: "3 小时前",
    readingMinutes: 5,
    content: [
      "这首歌的首日数据确实漂亮,但真正决定它能不能留下来的是第二天的表现。",
      "按照惯例,新歌首日通常会有一个明显的冲高,第二天回落属于正常现象。但这次的回落幅度比同类作品小了不少,说明有相当一部分听众在重复播放。",
      "评论区有个说法我觉得挺准:首日成绩看的是宣传,三日走势看的是歌本身。",
      "对听众来说,与其争论榜单名次,不如直接戴上耳机听一遍,好不好听自己的耳朵最清楚。",
    ],
    opinions: [
      { user: "单曲循环星人", stance: "歌迷", text: "已经循环一整天了,副歌部分真的很抓耳。", like: 421 },
      { user: "榜单不相信眼泪", stance: "数据派", text: "别只看名次,留存和复播才是关键指标。", like: 289 },
    ],
    comments: [
      { id: "c1", user: "通勤歌单收集者", avatarText: "通", time: "4 小时前", text: "加入通勤歌单了,地铁上一路单曲循环。", like: 132 },
    ],
  },
  {
    id: "6",
    title: "幕后故事:一场直播是怎么在二十分钟内改掉流程的?",
    summary: "观众看到的顺畅,背后往往是现场临时调整的结果。一位工作人员分享了那次「兵荒马乱」的救场经历。",
    categoryId: "show",
    categoryName: "综艺现场",
    tags: ["幕后", "直播", "专业素养"],
    author: "现场打杂的阿哲",
    authorTitle: "幕后分享者",
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20a%20director%20chair%20and%20clapperboard%20behind%20the%20scenes%2C%20warm%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=800&height=600&seq=gossip-topic-back-06&orientation=landscape",
    heat: 39800,
    commentCount: 436,
    likeCount: 2870,
    updatedAt: "5 小时前",
    readingMinutes: 6,
    content: [
      "那天临近开场,主嘉宾因为交通原因晚到了将近二十分钟。所有流程必须临时重排。",
      "导播第一时间把开场改为暖场互动,主持人临场加了一段和观众的对谈,把这二十分钟填得没有一丝空档。",
      "等嘉宾到场,整个流程顺滑地接了回去,大部分观众完全没察觉中间发生过调整。这种「看不见的专业」,才是现场最难的部分。",
      "写这篇不是为了夸谁,而是想让大家知道,镜头前那几分钟的从容,背后往往是几十个人同时在做判断。",
    ],
    opinions: [
      { user: "想做编导的学生", stance: "学习者", text: "这段临场处理太值得学了,等于上了一堂免费的现场课。", like: 356 },
      { user: "台下观众甲", stance: "感慨派", text: "当时我就在现场,完全没感觉出来,现在回看是真的服。", like: 241 },
    ],
    comments: [
      { id: "c1", user: "幕后感兴趣的人", avatarText: "幕", time: "6 小时前", text: "多想看这种真实的幕后分享,比花絮有用多了。", like: 118 },
    ],
  },
  {
    id: "7",
    title: "老剧重映为什么总能翻红?观众的怀旧情绪到底从哪来",
    summary: "一部十几年前的剧重回热搜,弹幕里全是「当年没看懂」。怀旧这件事,可能比我们想的更有价值。",
    categoryId: "film",
    categoryName: "影视热议",
    tags: ["怀旧", "重映", "经典重温"],
    author: "胶片收藏家",
    authorTitle: "影视区老面孔",
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20stacked%20old%20film%20cans%20and%20a%20warm%20lamp%2C%20warm%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=800&height=600&seq=gossip-topic-film-07&orientation=landscape",
    heat: 35400,
    commentCount: 398,
    likeCount: 2610,
    updatedAt: "昨天",
    readingMinutes: 5,
    content: [
      "经典老剧重映不是新鲜事,但这次讨论的热度超出了预期,连当年的演员采访都被翻了出来。",
      "有意思的是,这波讨论的主力并不是当年追剧的人,而是第一次看它的年轻观众。他们关注的点和上一代人完全不同。",
      "上一代看的是情感纠葛,年轻观众聊的是人物关系里的边界感和成长。同一部剧,被读出了两套完全不同的意义。",
      "这大概就是经典作品的价值——它经得起被反复解读,而且每一代人都能找到属于自己的那部分。",
    ],
    opinions: [
      { user: "第一次看的小年轻", stance: "新观众", text: "现在看完全没有过时感,甚至比很多新剧还细腻。", like: 298 },
      { user: "当年追过的人", stance: "老观众", text: "看到弹幕里新观众的反应,有种很奇妙的感觉。", like: 254 },
    ],
    comments: [
      { id: "c1", user: "经典剧重刷党", avatarText: "经", time: "昨天", text: "好的作品真的不怕时间,越看越有味道。", like: 97 },
    ],
  },
  {
    id: "8",
    title: "热搜词条背后:同一件事为什么会有两种完全相反的解读",
    summary: "同一个话题,评论区常常泾渭分明。是信息差,还是立场先行?我们来拆解讨论区里的两种声音。",
    categoryId: "net",
    categoryName: "网络热点",
    tags: ["舆论观察", "观点差异", "理性讨论"],
    author: "话题拆解员",
    authorTitle: "热点区评论员",
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20two%20contrasting%20speech%20bubbles%20in%20balance%2C%20warm%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=800&height=600&seq=gossip-topic-net-08&orientation=landscape",
    heat: 31200,
    commentCount: 512,
    likeCount: 2140,
    updatedAt: "昨天",
    readingMinutes: 4,
    content: [
      "同一个话题,刷十分钟评论你会发现,评论区像被分成了两个阵营,各说各的,谁也说服不了谁。",
      "很多时候并不是谁在撒谎,而是大家接收到的信息本来就不一样。你看到的片段和对方看到的片段,可能来自完全不同的时间点。",
      "另一种情况是立场先行:先选好队伍,再去找支持自己的证据。这时候讨论就不再是讨论,而变成了表态。",
      "社区一直鼓励的是——在评论之前先问自己一句「我是不是只看到了其中一部分」。理性不等于冷漠,而是愿意给不同声音留个位置。",
    ],
    opinions: [
      { user: "爱看评论区的人", stance: "理性派", text: "看完这篇我才意识到自己之前也太急着站队了。", like: 276 },
      { user: "信息收集员", stance: "考据派", text: "建议先看完完整信息再发言,真的能少很多误会。", like: 203 },
    ],
    comments: [
      { id: "c1", user: "沉默的看客", avatarText: "沉", time: "昨天", text: "能心平气和讨论问题的社区太少了,这里算一个。", like: 88 },
    ],
  },
  {
    id: "9",
    title: "从素人到舞台中央,一位新人歌手的第一次公开演出复盘",
    summary: "三首歌,八分钟,背后是半年的准备。社区跟踪记录了这位新人第一次登台的全过程。",
    categoryId: "stage",
    categoryName: "舞台演出",
    tags: ["新人", "舞台首秀", "成长记录"],
    author: "在台侧记录",
    authorTitle: "演出区记录者",
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20a%20single%20microphone%20under%20a%20spotlight%20on%20an%20empty%20stage%2C%20warm%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=800&height=600&seq=gossip-topic-stage-09&orientation=landscape",
    heat: 27600,
    commentCount: 324,
    likeCount: 1980,
    updatedAt: "2 天前",
    readingMinutes: 6,
    content: [
      "第一次站在真正的舞台上,他说自己紧张到忘了第一首歌的第一句词。但台下的观众几乎没有人发现。",
      "三首歌,八分钟。这个时长放在整场演出里并不算长,但对他来说,是从零到一的距离。",
      "演出结束后,他在后台发了一条很短的动态:「原来台下有人跟着唱的感觉是这样的。」",
      "社区里很多人留言鼓励他,有人分享自己第一次上台的经历,有人只是简单说了句「继续加油」。这些看似平常的留言,恰恰是一个社区最温暖的部分。",
    ],
    opinions: [
      { user: "第一次听他的观众", stance: "支持", text: "现场其实很稳,完全看不出是首秀。", like: 189 },
      { user: "也上过台的人", stance: "共情", text: "那种紧张只有站过台的人才懂,已经很棒了。", like: 156 },
    ],
    comments: [
      { id: "c1", user: "追梦的普通人", avatarText: "追", time: "2 天前", text: "看完特别想给自己也加个油,第一次总是最难的。", like: 76 },
    ],
  },
];

export const liveFeed: { user: string; text: string; topic: string }[] = [
  { user: "深夜看片人", text: "第八集那段我看了三遍还是想哭", topic: "影视热议" },
  { user: "沙发上的土豆", text: "那三秒沉默真的是神来之笔", topic: "综艺现场" },
  { user: "前排的耳机", text: "分时段入场今年确实改进了不少", topic: "舞台演出" },
  { user: "冲浪十级选手", text: "热梗真的不能刷太多,会腻", topic: "网络热点" },
  { user: "单曲循环星人", text: "副歌部分已经在我脑子里住了三天", topic: "音乐榜单" },
  { user: "台下观众甲", text: "当时就在现场,完全没看出改过流程", topic: "综艺现场" },
  { user: "第一次看的小年轻", text: "老剧放到现在看依旧不过时", topic: "影视热议" },
  { user: "沉默的看客", text: "先看完完整信息再发言,真的能少很多误会", topic: "网络热点" },
  { user: "追梦的普通人", text: "第一次总是最难的,加油", topic: "舞台演出" },
  { user: "通勤歌单收集者", text: "这首歌已经进我的通勤歌单了", topic: "音乐榜单" },
];

export const faqs: { q: string; a: string }[] = [
  { q: "17吃瓜社区是做什么的?", a: "这里是一个中文娱乐话题讨论社区。我们把影视、综艺、舞台演出、网络热点等大众娱乐话题整理成一个个可以参与讨论的话题,任何人都能看到不同角度的观点并留下自己的看法。" },
  { q: "参与讨论需要注册账号吗?", a: "浏览话题和查看评论不需要注册。如果你想发表观点、参与评论互动,则需要注册一个账号,这样可以保证讨论区的氛围和秩序。" },
  { q: "为什么同一个话题会有很多不同的观点?", a: "这正是我们想保留的部分。社区鼓励多元表达,只要是基于事实、尊重他人的讨论,我们都欢迎。不同观点的碰撞,往往比单一声音更有价值。" },
  { q: "话题内容是怎么选出来的?", a: "话题主要来自近期讨论度较高的娱乐事件和网友自发投稿。我们会优先选择能够持续讨论、具有讨论价值的话题,而不是只追一时的热度。" },
  { q: "如何订阅热门话题提醒?", a: "你可以在页面底部填写邮箱,订阅我们的热门话题日报。我们会把每天讨论度最高的话题整理成一封简短的邮件,方便你快速了解社区动态。" },
  { q: "社区对评论有什么要求?", a: "我们希望讨论保持理性和友善。请避免人身攻击、传播未经证实的信息以及恶意刷屏。对于违规评论,我们会视情况进行折叠或删除处理。" },
];

export const activeUsers: { name: string; title: string; score: number; badge: string }[] = [
  { name: "追剧的橘子", title: "影视区常驻楼主", score: 9820, badge: "ri-vip-crown-line" },
  { name: "网感研究所", title: "热点区观察者", score: 8640, badge: "ri-flashlight-line" },
  { name: "现场第一排", title: "演出区资深乐迷", score: 7910, badge: "ri-mic-line" },
  { name: "综艺观察员", title: "综艺区活跃网友", score: 7450, badge: "ri-tv-2-line" },
  { name: "耳机里的风", title: "音乐区数据党", score: 6880, badge: "ri-music-2-line" },
  { name: "话题拆解员", title: "热点区评论员", score: 6420, badge: "ri-chat-smile-2-line" },
];